export enum SpecialZoneType {
  DeadZone = 'deadZone',
  VehicleParkingZone = 'vehicleParkingZone',
  ActiveZone = 'activeZone',
  /** A named presence zone, stored server-side with its own id */
  PresenceZone = 'presenceZone',
  /**
   * A named presence line: an open polyline people cross rather than a
   * polygon they stand in. Same table and id as a zone; its point order
   * sets the crossing direction.
   */
  PresenceLine = 'presenceLine',
}

export interface Point {
  x: number;
  y: number;
}

export interface ZonePolygonData {
  id: string;
  /** A closed ring, or for a presence line the ordered points of the polyline */
  points: Point[];
  type: SpecialZoneType;
  /** Drawn inside the polygon (or beside the line). Presence zones are named; the others are not. */
  label?: string;
}

export interface CanvasDimensions {
  width: number;
  height: number;
}

export type HandleType = 'vertex' | 'midpoint';

export interface HandleData {
  type: HandleType;
  index: number;
  position: Point;
}
